module.exports = __webpack_public_path__ + "static/media/p-logo-ms.ab75d5d1.svg";